import * as React from 'react'
import {
  createFileRoute,
  useLoaderData,
} from '@tanstack/react-router'
import { createUserQueryOptions } from '@/services/auth/auth.options'
import { queryClient } from '@/lib/queryClient'
import UserProfile from '@/pages/userProfile/UserProfile.page'
import DashboardLayout from '@/layouts/DashboardLayout'

export const Route = createFileRoute('/_auth/user-profile')({
  loader: async ({ context: { queryClient } }) => {
    const query = createUserQueryOptions({
      customerid: 0,
      ticketid: 0,
      limittocustomer: false,
    })
    const agentContext = await queryClient.ensureQueryData(query)
    if (!agentContext?.ContextUser?.AgentId) {
      throw new Error('Agent context not found')
    }
    return { agentContext }
  },
  component: () => {
    const { agentContext } = useLoaderData({ from: '/_auth/user-profile' })
    return (
      <DashboardLayout title="User Profile">
        <UserProfile agentContext={agentContext} />
      </DashboardLayout>
    )
  },
})

const UserProfileLayout = () => {
  const { agentContext } = useLoaderData({ from: '/_auth/user-profile' })

  return (
    <DashboardLayout>
      <UserProfile agentContext={agentContext} />
    </DashboardLayout>
  )
}
